import { render, staticRenderFns } from "./teachersummary.vue?vue&type=template&id=7019bca4&scoped=true&"
import script from "./teachersummary.vue?vue&type=script&lang=js&"
export * from "./teachersummary.vue?vue&type=script&lang=js&"
import style0 from "./teachersummary.vue?vue&type=style&index=0&id=7019bca4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7019bca4",
  null
  
)

export default component.exports